<span
    [nbTooltip]="tooltipText"
    [innerHTML]="cellContent"></span>
